var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIccon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 250,
    viewBox: "0 0 199 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 26804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M94.3762 127.01C99.3248 127.01 103.336 123.26 103.336 118.634C103.336 114.008 99.3248 110.258 94.3762 110.258C89.4276 110.258 85.416 114.008 85.416 118.634C85.416 123.26 89.4276 127.01 94.3762 127.01Z",
    stroke: "#188AEC",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    d: "M93.2075 160.797C129.197 160.797 158.373 133.397 158.373 99.5979C158.373 65.7988 129.197 38.3992 93.2075 38.3992C57.2177 38.3992 28.0422 65.7988 28.0422 99.5979C28.0422 133.397 57.2177 160.797 93.2075 160.797Z",
    stroke: "#188AEC",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3",
    d: "M93.2076 170.996C135.456 170.996 169.706 139.03 169.706 99.5979C169.706 60.1656 135.456 28.1995 93.2076 28.1995C50.9587 28.1995 16.7092 60.1656 16.7092 99.5979C16.7092 139.03 50.9587 170.996 93.2076 170.996Z",
    stroke: "#188AEC",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M69.1248 101.121L80.5287 92.7553L69.1248 84.7917",
    stroke: "#188AEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M119.628 101.121L108.224 92.7553L119.628 84.7917",
    stroke: "#188AEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_4",
    d: "M142.932 10.1373C145.631 10.1373 147.819 8.09184 147.819 5.56865C147.819 3.04545 145.631 1 142.932 1C140.232 1 138.044 3.04545 138.044 5.56865C138.044 8.09184 140.232 10.1373 142.932 10.1373Z",
    stroke: "#188AEC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_5",
    d: "M193.435 34.5035C196.134 34.5035 198.322 32.4581 198.322 29.9349C198.322 27.4117 196.134 25.3662 193.435 25.3662C190.735 25.3662 188.547 27.4117 188.547 29.9349C188.547 32.4581 190.735 34.5035 193.435 34.5035Z",
    fill: "#188AEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-5",
    d: "M155.569 21.9507L169.186 34.6793M169.393 21.9507L155.776 34.6793L169.393 21.9507Z",
    stroke: "#188AEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-4",
    d: "M1.85474 49.1174L11.6295 58.2547M11.6295 49.1174L1.85474 58.2547L11.6295 49.1174Z",
    stroke: "#188AEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_6",
    d: "M24.0048 39.0721C26.7041 39.0721 28.8922 37.0267 28.8922 34.5035C28.8922 31.9803 26.7041 29.9348 24.0048 29.9348C21.3056 29.9348 19.1174 31.9803 19.1174 34.5035C19.1174 37.0267 21.3056 39.0721 24.0048 39.0721Z",
    fill: "#188AEC"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 19293",
    x: 37.8619,
    y: 169.057,
    width: 27.466,
    height: 74.8408,
    rx: 13.733,
    transform: "rotate(28.3226 37.8619 169.057)",
    stroke: "#188AEC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 255",
    d: "M45.0718 174.5L52.072 161",
    stroke: "#188AEC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 256",
    d: "M55.0718 179.5L62.072 166",
    stroke: "#188AEC",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIccon);
export default __webpack_public_path__ + "static/media/searchIccon.9865d3dd954085195715244ed436985d.svg";
export { ForwardRef as ReactComponent };